import deepcopy from "deepcopy";
import {
	LIST_PREFERENCE_CENTERS_SUCCESS,
	LIST_PREFERENCE_CENTERS_FAILURE,
	LIST_PREFERENCE_CENTERS_RESET,
	UPDATE_PREFERENCE_CENTER_INTERESTS_SUCCESS,
} from "./types";
let INITIAL_STATE = {
	preferenceCenters: null,
};
export const reducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
	case LIST_PREFERENCE_CENTERS_SUCCESS:
		return {
			...state,
			preferenceCenters: {
				listId: action.listId,
				preferenceCenters: action.data,
			},
		};
	case LIST_PREFERENCE_CENTERS_FAILURE:
		return {};
	case UPDATE_PREFERENCE_CENTER_INTERESTS_SUCCESS: {
		const copiedState = deepcopy(state.preferenceCenters);
		copiedState.preferenceCenters.data =
				copiedState.preferenceCenters.data.map((d) => {
					if (d.id == action.data.id) {
						return action.data;
					}
					return d;
				});
		const updatedState = {
			...state,
			preferenceCenters: copiedState,
		};
		return updatedState;
	}
	case LIST_PREFERENCE_CENTERS_RESET: {
		return INITIAL_STATE;
	}
	default:
		return state;
	}
};
